'use client';
import { createUnitParser } from '../../../modules/units/impl/createUnitParser/createUnitParser.js';

var lookup = {
    round: function() {
        return "200px";
    }
};
var borderRadius = function(param) {
    var unitBorderRadius = param.unitBorderRadius;
    return createUnitParser({
        suffix: "r",
        lookup: lookup,
        parseUnit: function(value) {
            if (value == null) {
                return "" + unitBorderRadius + "px";
            }
            return "" + unitBorderRadius * Number(value) + "px";
        }
    });
};

export { borderRadius };
